<template>
  <div class="promoteStatusBox">
    <div :class="['main', statusList[status].className]">
      <i></i>
      <p class="title">{{ statusList[status].title }}</p>
      <p class="tip">{{ statusList[status].tip }}</p>
      <span class="btn" v-if="statusList[status].btnText" @click="opation()">{{
        statusList[status].btnText
      }}</span>
    </div>
  </div>
</template>

<script>
export default {
   metaInfo() {
    return {
      title: "招募审核",
    };
  },
  name: "promoteStatus",
  data() {
    return {
      status: 1006,
      statusList: {
        1000: {
          className: "reading",
          title: "资料已提交，等待审核",
          tip: "已提交的申请将在2个工作日内完成审核，审核结果将以短信消息通知。",
          btnText: "",
          href: "",
        },
        1004: {
          className: "success",
          title: "恭喜您成为推广员",
          tip: "现在去推广，即可获得推广奖励",
          btnText: "前往推广中心",
          href: "home",
        },
        1006: {
          className: "error",
          title: "很遗憾，审核未通过！",
          tip: "您提交的申请申请暂未通过，如有疑问请联系客服人员18167176677(微信同号)咨询",
          btnText: "",
          href: "service",
        },
      },
      captcha:'',
    };
  },
  components: {},
  mounted() {
    this.getStatus();
  },
  methods: {
    getStatus() {
      this.$post(
        "/iart-api-crm/api/crm/custdistribution/queryByCustdistribution",
        {}
      ).then((res) => {
        if (this.util.processingData(res)) {
          if (res.code == 1) {
            var data = res.data;
            this.status = res.data ? res.data.companies.status : "";
            // if (data.promoter == "Y") {
            //   this.$router.push({
            //     path: "/h5/mine/promote/promote",
            //     query: {},
            //   });
            //   this.util.toast({ msg: '您已经是推广员' });
            // }
          } else {
            this.util.toast({ msg: res.message });
          }
        }
      });
    },
    opation() {
      var url = "",
        query = {};
      switch (this.statusList[this.status].href) {
        case "home":
          url = "/h5/mine/promote/promote";
          break;
        case "service":
          url = "/common/mine/serve";
          break;

        default:
          break;
      }
      if (url) {
        this.$router.replace({
          path: url,
          query: query,
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.promoteStatusBox {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: #fff;
  .main {
    margin: 16vh auto 0;
    text-align: center;
    i {
      display: inline-block;
      width: 62px;
      height: 62px;
    }

    .title {
      font-size: 14px;
      line-height: 20px;
      color: #333333;
      font-weight: bold;
      margin-top: 24px;
    }
    .tip {
      font-size: 12px;
      line-height: 18px;
      color: #aeafb1;
      margin: 12px 66px 0;
    }
    .btn {
      display: inline-block;
      font-size: 14px;
      font-weight: bold;
      line-height: 20px;
      text-align: center;
      border-radius: 3px;
    }
  }
  .reading i,
  .success i {
    background: url(../../../../assets/img/h5/success_full.png) no-repeat;
    background-size: 62px 62px;
  }
  .error i {
    background: url(../../../../assets/img/h5/error.png) no-repeat;
    background-size: 62px 62px;
  }
  .success .btn {
    color: #ffffff;
    background: #c9373d;
    padding: 14px 120px;
    margin-top: 107px;
  }

  .error .btn {
    color: #35363c;
    background: #f7f7f7;
    margin-top: 90px;
    padding: 14px 132px;
  }
}
</style>